import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'components/ui/button';
import Modal from 'components/shared/Modal';
import { getUserName } from 'helpers';

const AssignConfirmationModal = ({
  isOpen = false,
  isDisabled = false,
  onOpenChange = null,
  agency = null,
  pilgrim = null,
  onConfirm = null,
}) => {
  if (!agency || !pilgrim) return null;

  const isReassignment = pilgrim.currentAgency !== null;

  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={isReassignment ? "Confirmer le changement d'agence" : "Confirmer l'assignation"}
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Annuler
          </Button>
          <Button variant="hajj" onClick={onConfirm} disabled={isDisabled}>
            {isReassignment ? 'Confirmer le changement' : "Confirmer l'assignation"}
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <div className="bg-gray-50 rounded-lg p-4 space-y-2">
          <div className="flex justify-between">
            <span className="text-sm font-medium text-gray-700">Pèlerin :</span>
            <span className="text-sm font-semibold text-gray-900">
              {getUserName(pilgrim.pilgrim.first_name, pilgrim.pilgrim.last_name)}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm font-medium text-gray-700">NPI :</span>
            <span className="text-sm font-semibold text-gray-900">{pilgrim.pilgrim.npi}</span>
          </div>
        </div>

        <p className="text-sm text-gray-600">
          {isReassignment ? (
            <>
              Ce pèlerin sera réassigné à l&apos;agence <strong className="text-gray-900">{agency.name}</strong>.
            </>
          ) : (
            <>
              Voulez-vous vraiment assigner ce pèlerin à l&apos;agence{' '}
              <strong className="text-gray-900">{agency.name}</strong> ?
            </>
          )}
        </p>

        <div className="bg-emerald-50 rounded-lg p-3 space-y-1">
          <p className="text-xs font-medium text-emerald-900">Agence sélectionnée</p>
          <p className="text-sm font-semibold text-emerald-900">{agency.name}</p>
        </div>
      </div>
    </Modal>
  );
};

AssignConfirmationModal.propTypes = {
  isOpen: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onOpenChange: PropTypes.func,
  agency: PropTypes.shape([]),
  pilgrim: PropTypes.shape([]),
  onConfirm: PropTypes.func,
};

export default AssignConfirmationModal;
